import type { ChubbQuotePayload } from '@/services/chubbApi'
import type { QuoteData } from '@/types/quote.types'
import { hasAuthenticDemographics, isAuthenticGender } from './demographics'

function readVehicle(quoteData: QuoteData) {
  const { year } = quoteData
  const brandName = quoteData.brand?.name
  const modelName = quoteData.model?.name
  if (!year || !brandName || !modelName) return null
  return { year, brandName, modelName }
}

function readPostalCode(quoteData: QuoteData): string | null {
  const postalRaw = quoteData.personalData?.postalCode ?? quoteData.postalCode
  if (!postalRaw) return null
  const postalCode = String(postalRaw).padStart(5, '0')
  return /^\d{5}$/.test(postalCode) ? postalCode : null
}

/**
 * Build the widget Chubb API payload from legacy QuoteData.
 * Returns null when vehicle/CP/demographics are incomplete — caller must skip Chubb.
 */
export function buildLegacyChubbPayload(quoteData: QuoteData): ChubbQuotePayload | null {
  const vehicle = readVehicle(quoteData)
  const postalCode = readPostalCode(quoteData)
  const gender = quoteData.personalData?.gender
  const birthDate = quoteData.personalData?.birthDate

  if (!vehicle || !postalCode) return null
  if (!isAuthenticGender(gender) || !hasAuthenticDemographics(gender, birthDate)) return null

  return {
    ...vehicle,
    amis: quoteData.amis ?? quoteData.model?.id ?? '',
    postalCode,
    gender,
    birthDate,
  }
}
